module.exports = __webpack_public_path__ + "static/img/contact.0bb92827.png";